module.exports = __webpack_public_path__ + "VU-logo-9f4f5a9e215e7e90a91fa6ef6b04c55c.png";


//////////////////
// WEBPACK FOOTER
// ../images/VU-logo.png
// module id = 1250
// module chunks = 4 5